import React from 'react';
import { BadgeWithTooltip } from '../../../../../ui/AvatarTool/BadgeWithTooltip/BadgeWithTooltip';

type AlternatePriceTooltipProps = {
  id: string;
}

const content = (
  <div>
    <p>
      If player has this achievement, they will be charged the alternate price, if it’s lower than the regular price.
      <br />
      Player’s are always charged the lowest price for which they meet the requirements.
    </p>
  </div>
);

export function AlternatePriceTooltip(props: AlternatePriceTooltipProps) {
  const { id } = props;

  return (
    <div
      data-testid={id}
      className="position-absolute"
      style={{ top: '-1em', right: '-1em' }}
    >
      <BadgeWithTooltip
        id={id}
        title="Alternate Price Details"
        content={content}
      />
    </div>
  );
}
